import { atom, selector } from "recoil";
import { getCustomerSettings } from "../CustomerSettings";
import { savedDisplayOperationState } from "../hooks/useDisplayOperation";
import { getProperty } from "../utils/FPEUtils";

export const mapPerspectiveState = atom({
  key: 'mapPerspectiveState',
  default: selector({
    key: 'mapPerspectiveStateSelector',
    get: ({get}) => {
      return getProperty(get(savedDisplayOperationState), 'MAP') || getCustomerSettings('mapPerspective');
    }
  })
});